import { logAppError } from 'Helpers/logger'

import {
  toastShow,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR
} from 'mailup-web-components'
import { modalOpportunityState } from '../state/modal'
import { sendContactRequest } from '../actions/actions'
import getIntl from 'Helpers/intl'

export const OpportunityConfirmCallback = ({
  set,
  snapshot,
  reset
}) => async () => {
  const { email, type } = await snapshot.getPromise(modalOpportunityState)

  try {
    await sendContactRequest(email, type)

    toastShow(
      getIntl().formatMessage({
        id: 'Load.DeliverabilityIndex.ModalToastSuccess'
      }),
      TOAST_VARIANT_SUCCESS
    )
  } catch (error) {
    logAppError({
      Component: 'deliverability-dashboard',
      Method: 'BrandShieldContactConfirmCallback',
      appError: error
    })
    toastShow(
      getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      TOAST_VARIANT_ERROR
    )
  }
  reset(modalOpportunityState)
}
